export default __webpack_public_path__ + "static/media/movie-gallery.abadf980.png";